// NOTE: https://docs.imgproxy.net/generating_the_url?id=resizing-type

export enum ImageProxyResize {
  Auto = 'auto',
  Fill = 'fill',
  FillDown = 'fill-down',
  Fit = 'fit',
  Force = 'force',
}
